<script setup>
import { Bars3BottomLeftIcon } from '@heroicons/vue/24/outline'
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue'
</script>

<template>
  <Popover v-slot="{ open }" class="relative">
    <PopoverButton
      :class="open ? 'bg-gray-50' : 'text-opacity-90 shadow'"
      class="group inline-flex h-fit items-center rounded-md p-2 text-base font-medium text-white hover:text-opacity-100 focus:outline-2"
    >
      <div class="relative">
        <Bars3BottomLeftIcon class="size-6 stroke-zinc-500 sm:size-8" />
      </div>
    </PopoverButton>

    <transition
      enter-active-class="transition ease-out duration-100"
      enter-from-class="transform opacity-0 scale-95"
      enter-to-class="transform opacity-100 scale-100"
      leave-active-class="transition ease-in duration-75"
      leave-from-class="transform opacity-100 scale-100"
      leave-to-class="transform opacity-0 scale-95"
    >
      <PopoverPanel class="absolute z-50">
        <div
          class="z-50 flex w-56 flex-col space-y-2 rounded-r-lg bg-gray-50 p-4 pr-10 shadow-lg ring-1 ring-black/5"
        >
          <slot />
        </div>
      </PopoverPanel>
    </transition>
  </Popover>
</template>
